export const lib = {
	selectors: {
		events: '.events',
		truncate: '.event__description--truncate',
	},
	classes: {
		ctr: 'events__ctr',
		container: 'container',
		badges: 'badges',
		badge: 'badge',
		meta: 'event__meta',
		location: 'event__location',
		icon: 'event__icon',
		date: 'event__date',
		description: 'event__description',
		descriptionInner: 'event__description-inner',
		truncate: 'event__description--truncate',
		closed: 'event__description--closed',
		clamp: 'event__description--clamp',
		noEvents: 'event__no-events',
		infobox: 'infobox infobox--info-primary',
	},
};
